import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';
import { ActionPerformed, PushNotificationSchema, PushNotifications, Token } from '@capacitor/push-notifications';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { NavController, Platform } from '@ionic/angular';
import { Store } from '@ngxs/store';
import { Filter } from './interfaces';
import { ProductsFacade, PushNotificationRegister, ReloadCategorySearch } from './store';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent {
    constructor(
        private plt: Platform,
        private store: Store,
        private navCtrl: NavController,
        private productsFacade: ProductsFacade,
        private router: Router
    ) {
        this.plt.ready().then(async () => {
            if (this.plt.is('capacitor')) {
                if (this.plt.is('ios')) {
                    Keyboard.setAccessoryBarVisible({
                        isVisible: true
                    });
                    Keyboard.setResizeMode({
                        mode: KeyboardResize.None
                    });
                    StatusBar.setStyle({ style: Style.Light });
                }

                SplashScreen.hide();

                PushNotifications.requestPermissions().then((result) => {
                    if (result.receive === 'granted') {
                        // Register with Apple / Google to receive push via APNS/FCM
                        PushNotifications.register();
                    } else {
                        // Show some error
                    }
                });

                PushNotifications.addListener('registration', (token: Token) => {
                    console.log('Push registration success, token: ' + token.value);
                    this.store.dispatch(new PushNotificationRegister(token.value));
                });

                PushNotifications.addListener('registrationError', (error: any) => {
                    console.log('Error on registration: ' + JSON.stringify(error));
                });

                PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
                    console.log('Push received: ' + JSON.stringify(notification));
                });

                PushNotifications.addListener('pushNotificationActionPerformed', (notification: ActionPerformed) => {
                    console.log('Push action performed: ' + JSON.stringify(notification));
                    switch (notification.notification?.data?.route) {
                        case 'category':
                            const categoryData = JSON.parse(notification.notification.data.routeData);
                            this.goToCategory(categoryData.filter, categoryData.title);
                            break;
                        case 'favorites':
                            this.goToFavs();
                            break;
                        case 'product':
                            const productData = JSON.parse(notification.notification.data.routeData);
                            this.goToProduct(productData.id);
                            break;
                        case 'sellNow':
                            const sellProductData = JSON.parse(notification.notification.data.routeData);
                            this.goToSellNowProduct(sellProductData.id);
                            break;
                        case 'orders':
                            this.goToOrders();
                            break;
                        case 'cart':
                            this.goToCart();
                            break;
                        case 'voucher':
                            this.goToAccount();
                            break;
                    }
                    PushNotifications.removeAllDeliveredNotifications();
                });
            }
        });
    }

    private goToCategory(filters: Filter, title: string) {
        this.productsFacade.setListFilters(filters, title).subscribe({
            next: () => {
                if (this.router.url === '/search/products') {
                    // When the active page is the same, we manually load the list data
                    this.store.dispatch(new ReloadCategorySearch());
                } else {
                    this.navCtrl.navigateRoot('/search/products');
                }
            }
        });
    }

    private goToFavs() {
        this.navCtrl.navigateRoot(`/favorites`);
    }

    private goToProduct(id: string) {
        this.navCtrl.navigateForward(`/product/${id}`);
    }
    private goToSellNowProduct(id: string) {
        this.navCtrl.navigateForward(`/sell-now/product/${id}`);
    }

    private goToOrders() {
        this.navCtrl.navigateForward(`/account/orders`);
    }

    private goToCart() {
        // check if not already on the cart
        if (this.router.url !== '/cart') {
            this.navCtrl.navigateForward('/cart');
        }
    }

    private goToAccount() {
        if (this.router.url !== '/account') {
            this.navCtrl.navigateRoot('/account');
        }
    }
}
